import { mockFormField, mockFormFieldset } from '@domgen/dgx-fe-forms/layout';
import { CmsBillingAddressFieldset } from '../../models/cms/cms-billing-address-fieldset.interface';

export const mockCmsBillingAddressFieldset: CmsBillingAddressFieldset = {
  ...mockFormFieldset,
  billingAddressSameAsAddressField: mockFormField,
};
